// Constants
import { CALLBACK_URL_QUERY_PARAM } from 'providers/token/handlers/constants/token.handlers.constants';
// Enumerations
import { CharactersEnum } from '@openbank/ziniaweb-ui-core-models';

const getCheckoutIdFromUrl = (): string => window.location.pathname.split(CharactersEnum.SLASH)[1];

const getCallbackUrl = (): string => {
  const callbackUrl =
    new URLSearchParams(window.location.search).get(CALLBACK_URL_QUERY_PARAM) || '';

  return callbackUrl ? callbackUrl : '';
};

export { getCheckoutIdFromUrl, getCallbackUrl };
